export const comments_5187252 = {"data":{"data":[],"links":{}}}